<div>
@if (peblFormData) {
  <div class="pebl-dialog">
    <div class="pebl-dialog__header">
      <div class="pebl-dialog__header-main">
        <p class="pebl-dialog__eyebrow">Payment Link</p>
        <h1 class="pebl-dialog__amount">
          {{ peblFormData.amount | currency: currencyAlphaCode }}
        </h1>
      </div>
      <button
        mat-icon-button
        class="pebl-dialog__close"
        [disabled]="processing"
        [mat-dialog-close]
        data-test="app-pebl-confirmation-close-icon-button"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="pebl-dialog__badge-row">
      <span class="pebl-dialog__badge mon-bg-primary mon-text-primary">
        <mat-icon class="outline">{{ deliveryIcon() }}</mat-icon>
        {{ SendTypeMapper(peblFormData.method) }}
      </span>
      @if (peblFormData.scheduleEnabled) {
        <span class="pebl-dialog__badge mon-bg-warning mon-text-warning">
          <mat-icon class="outline">schedule</mat-icon>
          {{ peblFormData.scheduleMode === 'recurring' ? 'Recurring' : 'Scheduled' }}
        </span>
      }
    </div>

    <mat-dialog-content class="pebl-dialog__body">
      <div class="pebl-dialog__section">
        <h2 class="pebl-dialog__section-title">Overview</h2>
        <div class="pebl-dialog__grid">
          <div class="pebl-dialog__item">
            <span class="pebl-dialog__label">Name</span>
            <p class="pebl-dialog__value">{{ peblFormData.name }}</p>
          </div>
          <div class="pebl-dialog__item">
            <span class="pebl-dialog__label">Link Expires in</span>
            <p class="pebl-dialog__value">
              {{ LinkExpiryMapper(peblFormData.preparedPaymentMinutes) }}
            </p>
          </div>
          <div class="pebl-dialog__item pebl-dialog__item--full">
            <span class="pebl-dialog__label">Description</span>
            <p class="pebl-dialog__value">{{ peblFormData.paymentDetail }}</p>
          </div>

          @if (peblFormData.scheduleEnabled && peblFormData.scheduleMode === 'once') {
            <div class="pebl-dialog__item pebl-dialog__item--full">
              <span class="pebl-dialog__label">Scheduled Send</span>
              <p class="pebl-dialog__value">
                {{ peblFormData.sendAt | date: 'd MMM yyyy, HH:mm' }}
              </p>
            </div>
          }

          @if (peblFormData.scheduleEnabled && peblFormData.scheduleMode === 'recurring') {
            <div class="pebl-dialog__item pebl-dialog__item--full">
              <span class="pebl-dialog__label">Schedule</span>
              <p class="pebl-dialog__value">
                {{ peblFormData.frequency | titlecase }} from
                {{ peblFormData.startDate | date: 'd MMM yyyy, HH:mm' }}
                @if (peblFormData.endCondition === 'occurrences') {
                  <ng-container>, {{ peblFormData.occurrences }} sends</ng-container>
                }
                @if (peblFormData.endCondition === 'endDate') {
                  <ng-container>, until {{ peblFormData.endDate | date: 'd MMM yyyy' }}</ng-container>
                }
              </p>
            </div>
          }
        </div>
      </div>
    </mat-dialog-content>

    <div class="pebl-dialog__actions">
      <button
        mat-stroked-button
        color="warn"
        [disabled]="processing"
        [mat-dialog-close]
        cdkFocusInitial
      >
        Cancel
      </button>
      <div class="pebl-dialog__actions-spacer"></div>
      <button
        mat-flat-button
        color="primary"
        [disabled]="processing"
        (click)="MakePEBLRequest()"
        data-test="app-pebl-confirmation-make-peblrequest-button"
      >
        @if (processing) {
          <mat-progress-spinner
            class="pebl-dialog__submit-spinner"
            mode="indeterminate"
            diameter="20"
            strokeWidth="3"
            data-test="app-pebl-confirmation-submit-spinner"
          ></mat-progress-spinner>
        } @else {
          Submit
        }
      </button>
    </div>
  </div>
}
</div>
